import { render, staticRenderFns } from "./TopRecommendedFormats.vue?vue&type=template&id=e1ec10ca"
import script from "./TopRecommendedFormats.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopRecommendedFormats.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports